import { useCallback } from "react";
import { useIsomorphicLayoutEffect } from "usehooks-ts";
import debounce from "lodash/debounce";
import { useShellStore } from "@/features/shell/stores/shellStore";

const useGlobalWindowSize = () => {
  const windowSize = useShellStore((state) => state.windowSize);
  const setWindowSize = useShellStore((state) => state.setWindowSize);

  const handleResize = useCallback(
    debounce(() => {
      setWindowSize({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }, 200),
    [],
  );

  useIsomorphicLayoutEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowSize;
};

const useWindowSize = () => {
  const windowSize = useShellStore((state) => state.windowSize);
  return windowSize;
};

export { useGlobalWindowSize };

export default useWindowSize;
